/**
 * @module components\ghTable\dataTable\dataRow\dataCell\selectionCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";
import { MethodService } from "@/utils/serviceModel";
import { State, namespace, Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

const module = namespace("dbModule");

@Component
export default class SelectionCell extends DataCellBase {
  private get display() {
    let value = this.value;
    if (this.props.item && this.header.textColumn) {
      value = this.props.item[this.header.textColumn];
    }

    return value;
  }

  // @module.State(state => state.columnsSource)
  // private sources: { [key: string]: IColumnSourceState };

  // @module.State(state => state.currentColumnChangedId)
  // private changedColumnId: string;

  // @module.Action("fetchColumnSource")
  // private fetch;

  // private get loading() {
  //   if (this.sources && this.header.Id) {
  //     let source = this.sources[this.header.Id];
  //     if (source) {
  //       return source.loading;
  //     }
  //   }
  //   return false;
  // }

  // private items: any = null;

  // private refresh() {
  //   this.fetch(this.header.Id);
  // }

  // @Watch("sources")
  // private observeChangedColumnId() {
  //   if (this.header && this.header.Id) {
  //     if (this.header.Id === this.changedColumnId) {
  //       if (this.sources[this.header.Id]) {
  //         this.items = this.sources[this.header.Id].dataSource;
  //       }
  //     }
  //   }
  // }

  // created() {
  //   if (!this.items || this.items.length === 0) {
  //     this.refresh();
  //   }
  // }
}
